import React from 'react';
import useTranslation from '../../../../Hooks/useTranslation';
import styles from './DataTableCount.module.scss';

interface Props {
	count: number;
}

const DataTableCount = ({ count }: Props) => {
	const { t } = useTranslation();

	return (
		<div className={styles.wrapper}>
			<span className={styles.count}>
				{t('base.shared.dataTableTotalCount', { count: String(count) })}
			</span>
		</div>
	);
};

export default DataTableCount;
